module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('c-navbar', {
    attrs: {
      "title": "邀请有礼"
    }
  }), _vm._v(" "), _c('c-content', [_c('div', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('h2', [_c('span', {
    staticStyle: {
      "font-family": "微软雅黑, \"Microsoft YaHei\""
    }
  }, [_vm._v("【奖励条款】")])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "微软雅黑, \"Microsoft YaHei\""
    }
  }, [_vm._v("1、邀请人数不限，多邀多得，上不封顶")])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "微软雅黑, \"Microsoft YaHei\""
    }
  }, [_vm._v("2、现金奖励仅限于生意专家自营功能和服务，包括高级版、行业版、连锁后台、小程序及微信会员卡等（硬件设备不计入奖励）")])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "微软雅黑, \"Microsoft YaHei\""
    }
  }, [_vm._v("3、被邀请人实际付款部分产生现金奖励，抵值券、积分、优惠券抵扣的部分不计奖励")])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "微软雅黑, \"Microsoft YaHei\""
    }
  }, [_vm._v("4、正在进行促销活动的功能和套餐不产生现金奖励")])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "微软雅黑, \"Microsoft YaHei\""
    }
  }, [_vm._v("5、奖励金额为符合条件的消费金额之20%，直接通过微信公众号发送现金红包")])]), _vm._v(" "), _c('h2', [_c('span', {
    staticStyle: {
      "font-family": "微软雅黑, \"Microsoft YaHei\""
    }
  }, [_vm._v("【邀请条款】")])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "微软雅黑, \"Microsoft YaHei\""
    }
  }, [_vm._v("1、通过本页面的链接邀请，微信转发给老板、店长，注册后即与您的帐号关联")])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "微软雅黑, \"Microsoft YaHei\""
    }
  }, [_vm._v("2、受邀者完成注册或消费后即产生奖金记录，您需要关注公众号领取，奖金将会通过现金红包的方式直接发放给您")])]), _vm._v(" "), _c('h2', [_c('span', {
    staticStyle: {
      "font-family": "微软雅黑, \"Microsoft YaHei\""
    }
  }, [_vm._v("【安全免责条款】")])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "微软雅黑, \"Microsoft YaHei\""
    }
  }, [_vm._v("1、奖金原则上尽快发放，也有可能风控原因延迟，具体情况根据页面中的邀请记录及相关状态为准")])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "微软雅黑, \"Microsoft YaHei\""
    }
  }, [_vm._v("2、受邀者应为店主、老板、店长，并真实使用过生意专家提供的产品和服务")])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "微软雅黑, \"Microsoft YaHei\""
    }
  }, [_vm._v("3、为了保护各方利益，如发现有“撸羊毛”等欺骗奖金的行为（不仅限于欺骗注册等），本公司将采用大数据及AI外呼进行风控，并予以取消奖励和关停帐号")])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "微软雅黑, \"Microsoft YaHei\""
    }
  }, [_vm._v("4、最终解释权归生意专家所有")])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "微软雅黑, \"Microsoft YaHei\""
    }
  }, [_vm._v("5、如有疑问请联系客服【YL8866】")])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d9c95a2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/provision/index.vue
// module id = 1037
// module chunks = 2